import React, { useState, useEffect } from 'react';
import * as WidgetBlocks from '@metservice/mov-report-view-blocks';
import * as staticViewBlocks from '@mono/static-view-blocks';
import styled from 'styled-components';
import { FundOutlined, CopyOutlined, EditOutlined, CloseOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';

import WidgetBlockContainer from './WidgetBlockContainer';
import StaticViewBlockContainer from './StaticViewBlockContainer';
import { ItemButton } from './common/ItemButton';

const _ = require('lodash');

const ReportEditorItemStyled = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    .ItemControls {
        display: none;
    }

    :hover {
        .ItemControls {
            display: flex;
        }
    }
`;

const ItemControls = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    font-size: 24px;
    flex-direction: row;
    background-color: rgb(204, 204, 204);
`;

export const UNDELETABLE_VIEWBLOCK_TYPES = ['footer', 'header'];

export default ({ item, onDelete, onStartEditing, onExport, onToggleLock, onDuplicate, isLocked, timezone, datasets, cfjsons, isLoading }) => {
    const [now, setNow] = useState(new Date());

    const widgetBlock = WidgetBlocks;
    const isWidgetBlock = !WidgetBlocks[item.type] ? false : true;
    const reportViewBlocks = Object.assign({}, staticViewBlocks, widgetBlock);
    const reportViewBlock = reportViewBlocks[item.type];

    const shouldAllowEdit = isWidgetBlock ? reportViewBlock.widgetConfigurator : reportViewBlock.configurator;
    const shouldAllowDelete = !_.includes(UNDELETABLE_VIEWBLOCK_TYPES, item.type);
    const shouldAllowLock = shouldAllowDelete;
    const shouldAllowDuplicate = shouldAllowDelete;
    const lockIcon = isLocked ? <LockOutlined /> : <UnlockOutlined />;

    useEffect(() => {
        setNow(new Date());
    }, [item.viewblockState]);

    return (
        <ReportEditorItemStyled>
            {isWidgetBlock && (
                <WidgetBlockContainer
                    widgetblockType={item.type}
                    viewblockState={item.viewblockState}
                    date={now}
                    timezone={timezone}
                    datasets={datasets}
                    cfjsons={cfjsons}
                    isLoading={isLoading}
                />
            )}
            {!isWidgetBlock && <StaticViewBlockContainer reportViewBlockType={item.type} viewblockState={item.viewblockState} date={now} timezone={timezone} />}
            <ItemControls className='ItemControls'>
                {shouldAllowLock && <ItemButton onClick={onToggleLock} IconProp={lockIcon} />}
                {onExport && <ItemButton onClick={onExport} IconProp={<FundOutlined />} />}
                {shouldAllowDuplicate && <ItemButton onClick={onDuplicate} IconProp={<CopyOutlined />} />}
                {shouldAllowEdit && <ItemButton onClick={onStartEditing} IconProp={<EditOutlined />} />}
                {shouldAllowDelete && <ItemButton onClick={onDelete} IconProp={<CloseOutlined />} />}
            </ItemControls>
        </ReportEditorItemStyled>
    );
};
